module.exports = __webpack_public_path__ + "static/media/cross-lg-white.c67735c6.svg";